// extracted by mini-css-extract-plugin
export default {"melodyVideo":"eP-z","isFullWidth":"fP-z","landingPageVideo":"gP-z","play":"hP-z","iframeVideo":"iP-z","playHidden":"jP-z","fullwidth":"kP-z"};